/**
 * <yg-size-stock> — beden butonlarının altına stok notu ("Son 2") basar.
 *
 * NEDEN JS GEREKİYOR: Horizon, beden değişiminde <variant-picker>'ı sunucudan
 * gelen HTML ile morph ediyor ve sonradan eklenen düğümleri siliyor
 * (assets/morph.js). Bu yüzden not her morph sonrası yeniden basılıyor.
 * MutationObserver geri çağrısı mikro-görevde, boyamadan ÖNCE çalıştığı için
 * görünür titreme olmuyor.
 *
 * İŞ MANTIĞI YOK: hangi bedende ne yazacağı Liquid'de hesaplanıp bu elemanın
 * içindeki JSON'da taşınıyor. Burada yalnızca DOM'a yazma var.
 *
 * Çekirdek dosyaya (snippets/variant-main-picker.liquid) bilinçli olarak
 * DOKUNULMADI — o dosya şu an tamamen vanilla, ilk dokunuş her Horizon
 * güncellemesinde yeniden uygulanacak bir yük yaratırdı.
 */
const NOT_SINIFI = 'yg-size-stock__note';

class YgSizeStock extends HTMLElement {
  #picker = null;
  #observer = null;
  #yaziyor = false;

  connectedCallback() {
    const kapsam = this.closest('.product-details') || document;
    this.#picker = kapsam.querySelector('variant-picker');
    if (!this.#picker) return;

    this.#observer = new MutationObserver(() => this.#bas());
    this.#observer.observe(this.#picker, { childList: true, subtree: true });
    this.#bas();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #bas() {
    if (!this.#picker || this.#yaziyor) return;

    let harita = {};
    try {
      harita = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '{}');
    } catch {
      return;
    }

    // Hiçbir bedende not yoksa hiç dokunma: butonlar bugünkü haliyle kalsın.
    if (!Object.values(harita).some(Boolean)) return;

    const ad = this.dataset.optionName || 'Beden';
    let girisler;
    try {
      girisler = this.#picker.querySelectorAll(
        `input[type="radio"][data-option-name="${CSS.escape(ad)}"]`
      );
    } catch {
      return;
    }
    if (!girisler.length) return;

    this.#yaziyor = true;
    this.#observer?.disconnect();
    try {
      for (const giris of girisler) {
        const etiket = giris.closest('label');
        if (!etiket) continue;

        const not = harita[giris.value] || '';
        let span = etiket.querySelector('.' + NOT_SINIFI);
        if (!span) {
          span = document.createElement('span');
          span.className = NOT_SINIFI;
          etiket.append(span);
        }
        if (span.textContent !== not) span.textContent = not;

        // Ekran okuyucu da duysun
        const aria = giris.getAttribute('aria-label');
        if (not && aria && !aria.includes(not)) {
          giris.setAttribute('aria-label', `${aria}, ${not}`);
        }
      }
    } finally {
      this.#observer?.observe(this.#picker, { childList: true, subtree: true });
      this.#yaziyor = false;
    }
  }
}

if (!customElements.get('yg-size-stock')) {
  customElements.define('yg-size-stock', YgSizeStock);
}
